module.exports = __webpack_public_path__ + "static/1-798ab19b01134560907a95429673f77f.jpg";